import moment from 'moment-timezone';

export const localTime = (value, timezone) => moment.utc(value).tz(timezone).format('YYYY-MM-DDTHH:mm');

export function initialSubmission(context) {
  const start = localTime(context.shiftStartTime, context.timezone);
  const end = localTime(context.shiftEndTime, context.timezone);
  return {
    start,
    end,
    onSite: String(moment(context.shiftEndTime).diff(moment(context.shiftStartTime), 'minutes')),
    offSite: '0',
    rows: [{ id: 0, timeTypeId: context.timeTypes.length === 1 ? context.timeTypes[0].key : '', start, end }],
    breaks: [],
    witnessName: '',
    witnessRole: '',
  };
}

function toUtc(value, context, preferredOriginal) {
  // Preserve the offset of a scheduled time during the repeated DST hour.
  const original = [preferredOriginal, context.shiftStartTime, context.shiftEndTime].find(time => localTime(time, context.timezone) === value);
  if (original) return moment.utc(original).toISOString();
  const time = moment.tz(value, 'YYYY-MM-DDTHH:mm', true, context.timezone);
  if (!time.isValid() || time.format('YYYY-MM-DDTHH:mm') !== value) throw new Error('Enter a valid date and time in the site timezone.');
  return time.toISOString();
}

export function submissionPayload(draft, context, timesheetKey) {
  const range = ({ start, end }) => {
    const result = { start: toUtc(start, context, context.shiftStartTime), end: toUtc(end, context, context.shiftEndTime) };
    if (!moment(result.end).isAfter(result.start)) throw new Error('End time must be after start time.');
    return result;
  };
  let times;
  if (context.timesheetTypeKey === 'start-end') {
    const { start, end } = range(draft);
    times = [{ label: 'Start', value: start }, { label: 'End', value: end }];
  } else if (context.timesheetTypeKey === 'start-end-multi') {
    if (!draft.rows.length) throw new Error('Add at least one time block.');
    times = draft.rows.map(row => {
      if (!context.timeTypes.some(type => type.key === row.timeTypeId)) throw new Error('Select a time type for every block.');
      return { timeTypeId: row.timeTypeId, ...range(row) };
    });
  } else if (context.timesheetTypeKey === 'on-site-off-site') {
    if (![draft.onSite, draft.offSite].every(value => /^\d+$/.test(String(value)))) throw new Error('Durations must be whole, non-negative minutes.');
    if (Number(draft.onSite) + Number(draft.offSite) <= 0) throw new Error('Enter a positive working duration.');
    times = [{ label: 'On-Site', value: Number(draft.onSite) }, { label: 'Off-Site', value: Number(draft.offSite) }];
  } else throw new Error('Unsupported timesheet format.');
  if (context.requiresWitness && (!draft.witnessName.trim() || !draft.witnessRole.trim())) throw new Error('Enter the witness name and role.');
  return {
    timesheetKey,
    submissionData: { times, breaks: context.timesheetTypeKey === 'on-site-off-site' ? null : draft.breaks.map(range) },
    witnessName: draft.witnessName.trim(),
    witnessRole: draft.witnessRole.trim(),
  };
}

export function submissionError(response) {
  return response?.body?.overlapInfo ? `This overlaps another timesheet: ${response.body.overlapInfo}`
    : response?.body?.error?.message || response?.body?.message || (typeof response?.body?.error === 'string' && response.body.error) || 'Unable to submit the timesheet. Please try again.';
}
